const DEFAULT_SDK_SCRIPT_URL = 'https://sdk.novij.tech/js/releases/latest.esm.js';

let sdkModulePromise = null;
let sdkPromise = null;

export function getSdkConfig() {
  const ntpConfig = globalThis.window?.NTP_CONFIG || {};
  const statsConfig = globalThis.window?.NOVIJ_STATS_CONFIG || {};
  const query = readQueryOverrides();
  return {
    sdkScriptUrl: query.sdk || statsConfig.sdkScriptUrl || ntpConfig.sdkScriptUrl || DEFAULT_SDK_SCRIPT_URL,
    bootstrapUrl: query.bootstrap || statsConfig.bootstrapUrl || ntpConfig.bootstrapUrl || ntpConfig.peerBootstrapUrl || '',
    relayUrl: query.relay || statsConfig.relayUrl || statsConfig.relay || ntpConfig.relayUrl || ntpConfig.relay || '',
    storageUrl: query.storage || statsConfig.storageUrl || statsConfig.storage || ntpConfig.storageUrl || ntpConfig.storage || '',
    environment: statsConfig.environment || ntpConfig.environment || 'mainnet',
  };
}

export async function getStatsSdk(config = getSdkConfig()) {
  if (!sdkPromise) {
    sdkPromise = loadSdkModule(config).then((mod) => {
      if (typeof mod.createNovijSDK !== 'function') {
        throw new Error('В Novij SDK не найден экспорт createNovijSDK.');
      }
      return mod.createNovijSDK({
        environment: config.environment || 'mainnet',
        protocol: { version: 3 },
        bootstrapUrl: config.bootstrapUrl || undefined,
        relay: config.relayUrl || undefined,
        storage: config.storageUrl || undefined,
        logging: { level: 'warn' },
      });
    });
  }
  return sdkPromise;
}

export async function getSdkRelayBaseUrl(config = getSdkConfig()) {
  const explicitRelay = normalizeBaseUrl(config.relayUrl);
  if (explicitRelay) return explicitRelay;

  const sdk = await getStatsSdk(config);
  const current = normalizeBaseUrl(sdk?.connection?.relays?.current);
  if (current) return current;

  if (typeof sdk?.connection?.relays?.selectOptimal === 'function') {
    await sdk.connection.relays.selectOptimal({ reason: 'stats' });
    const selected = normalizeBaseUrl(sdk.connection.relays.current);
    if (selected) return selected;
  }

  throw new Error('Novij SDK не вернул активный relay endpoint.');
}

export function resetStatsSdkForTests() {
  sdkModulePromise = null;
  sdkPromise = null;
}

async function loadSdkModule(config) {
  if (!sdkModulePromise) {
    sdkModulePromise = import(/* @vite-ignore */ config.sdkScriptUrl || DEFAULT_SDK_SCRIPT_URL);
  }
  return sdkModulePromise;
}

function readQueryOverrides() {
  if (!globalThis.window?.location?.href || typeof URL === 'undefined') return {};
  try {
    const params = new URL(globalThis.window.location.href).searchParams;
    return {
      sdk: params.get('sdk') || '',
      bootstrap: params.get('bootstrap') || '',
      relay: params.get('relay') || '',
      storage: params.get('storage') || '',
    };
  } catch (_) {
    return {};
  }
}

function normalizeBaseUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.replace(/\/+$/, '');
}
